import { CloseOutlined } from "../../../../components/icons";

const ModalInternal = ({ onCancel, title, children }) => {
    return (
        <div className="fixed inset-0 bg-[#00000048] flex items-center justify-center z-50">
            <div className="w-[300px] max-h-[700px] md:w-[500px] bg-white rounded-md p-4">
                <div className="w-full h-[80px] flex justify-between items-center">
                    <p className="font-bold  text-[16px] md:text-[20px]">{title}</p>
                    <div onClick={() => onCancel()} className="w-[30px] h-[30px] cursor-pointer">
                        <CloseOutlined />
                    </div>
                </div>
                {children}
            </div>
        </div>
    )
}

export default ModalInternal